import { cache } from 'src/feathers/hooks';
import { yup } from 'straightline-utils/validation';

const validateQuery = async (context) => {
  const schema = yup.object({
    date: yup.date().label('Date'),
    latitude: yup.number().latitude().label('Latitude').required(),
    longitude: yup.number().longitude().label('Longitude').required()
  });
  context.params.query = await schema.validateQuery(context.params.query);
  return context;
};

export default {
  before: {
    find: [validateQuery, cache]
  },
  after: {
    find: [cache]
  },
  error: {
    find: []
  }
};
